var _path, _path2, _path3, _path4, _path5, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 23.5659C15.6569 23.5659 17 22.2228 17 20.5659C17 18.9091 15.6569 17.5659 14 17.5659C12.3431 17.5659 11 18.9091 11 20.5659C11 22.2228 12.3431 23.5659 14 23.5659Z",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 17.5659C27.6569 17.5659 29 16.2228 29 14.5659C29 12.9091 27.6569 11.5659 26 11.5659C24.3431 11.5659 23 12.9091 23 14.5659C23 16.2228 24.3431 17.5659 26 17.5659Z",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 29.5659C27.6569 29.5659 29 28.2228 29 26.5659C29 24.9091 27.6569 23.5659 26 23.5659C24.3431 23.5659 23 24.9091 23 26.5659C23 28.2228 24.3431 29.5659 26 29.5659Z",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7002 19.266L23.3002 15.866",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7002 21.866L23.3002 25.266",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.5659,
    r: 19.5,
    stroke: "#E2E8F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.8c9ae3a4cc90e9d7b30ce9ec57ee38d4.svg";
export { ForwardRef as ReactComponent };